import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { BouColor } from '../../global/bou-colors';
import { BouSvgIcon } from '../bou-svg-icon';

interface Props {
  icon: IconLookup | JSX.Element;
  style?: CSSProperties;
  title?: string;
}

export const AwesomeActionIcon = (props: Props) => {
  const { icon } = props;

  if (isFaIcon(icon)) {
    return <FAIcon style={props.style} icon={icon} title={props.title} />;
  }
  return <SLIcon style={props.style} icon={icon} title={props.title} />;
};

// FontAwesome icons have a "prefix" property, Streamline icons do not.
function isFaIcon(icon: IconLookup | JSX.Element): icon is IconLookup {
  if ((icon as Partial<IconLookup>).prefix) return true;
  return false;
}

const iconStyles = css`
  color: ${BouColor.TOOL_TEXT_BLACK};
  &:hover {
    color: ${BouColor.TOOL_HOVER_DARK_GRAY};
  }
  &:active {
    color: ${BouColor.TOOL_HOVER_DARK_GRAY};
  }
  cursor: pointer;
`.join('');

const FAIcon = styled(FontAwesomeIcon)`
  ${iconStyles}
`;

const SLIcon = styled(BouSvgIcon)`
  ${iconStyles}
`;
